import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ASC, IDLE, PENDING, PUBLIC } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadAllPackages,
    LoadAllowedPackagesForAccount,
    LoadAccountPackageById,
    SortPackages,
    setPackageList,
    setAccountPackageEdit,
    setAccountPackageAllowed,
    setAccountPackageReloadEdit,
    initAccountPackage,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface EditAccountPackageProps {
    id: number
    accountId: number
}

const Edit = ({
    id = null,
    accountId = null,
}: EditAccountPackageProps) => {
    const accountPackage = useSelector((state: StoreType) => state.accountPackage.accountPackageEdit)
    const reloadEdit = useSelector((state: StoreType) => state.accountPackage.reloadEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setAccountPackageReloadEdit(false))
        setTimeout(() => {
            dispatch(setAccountPackageReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        const promiseArray: Promise<any>[] = [
            LoadAllPackages().then((packageList) => {
                dispatch(setPackageList(packageList))

                LoadAllowedPackagesForAccount(accountId).then((allowedPackageIds) => {
                    if (allowedPackageIds.length) {
                        const sortedPackageIds = SortPackages(Object.values(packageList), "name", ASC, {})
                        const allowedSorted = sortedPackageIds.filter((row) => allowedPackageIds.includes(row))
                        dispatch(setAccountPackageAllowed(allowedSorted))
                    } else {
                        const sortedPackageIds = SortPackages(Object.values(packageList), "name", ASC, { visibility: PUBLIC })
                        dispatch(setAccountPackageAllowed(sortedPackageIds))
                    }
                })
            }),
        ]

        if (id === 0) {
            dispatch(setAccountPackageEdit(initAccountPackage))
        } else {
            promiseArray.push(
                LoadAccountPackageById(id, accountId).then((res) => {
                    dispatch(setAccountPackageEdit(res))
                }),
            )
        }

        setLoadState(PENDING)
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
            reload()
        })
    }, [])

    if (!accountPackage) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {accountPackage.id ? lang.editAccountPackage : lang.addAccountPackage}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form accountPackage={accountPackage} />
                }
                {
                    reloadEdit
                    && <Form accountPackage={accountPackage} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
